import moment from 'moment';
import uniq from 'lodash/uniq';

export function getUser() {
  let email = sessionStorage.getItem('email') ? sessionStorage.getItem('email') : localStorage.getItem('email');
  return email;
}

export const getMainLogo = () => require('../images/logo.png');

export function convertDay(num) {
  switch (num) {
    case 1:
      return 'Monday';
    case 2:
      return 'Tuesday';
    case 3:
      return 'Wednesday';
    case 4:
      return 'Thursday';
    case 5:
      return 'Friday';
    case 6:
      return 'Saturday';
    case 7:
      return 'Sunday';
    default:
      return;
  }
}

export function convertDayShort(num) {
  switch (num) {
    case 1:
      return 'M';
    case 2:
      return 'T';
    case 3:
      return 'W';
    case 4:
      return 'Th';
    case 5:
      return 'F';
    case 6:
      return 'Sat';
    case 7:
      return 'Sun';
    default:
      return;
  }
}

export function openInNewTab(url) {
  var win = window.open(url, '_blank');
  win.focus();
}

export const serializeParams = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
};

export const getRankByNumber = (number) => {
  const ranks = {
    0: 'Favorite',
    1: 'Great',
    2: 'Good',
    3: 'Acceptable'
  };

  return ranks[number];
}

export const getNumberByRank = (rank) => {
  const ranks = {
    'favorite': 0,
    'great': 1,
    'good': 2,
    'acceptable': 3
  };

  return ranks[rank];
}


export function getWeekDays(weekStart) {
  const days = [weekStart];
  for (let i = 1; i < 7; i += 1) {
    days.push(
      moment(weekStart)
        .add(i, 'days')
        .toDate()
    );
  }
  return days;
}

export function getWeekRange(date) {
  return {
    from: moment(date)
      .startOf('week')
      .toDate(),
    to: moment(date)
      .endOf('week')
      .toDate()
  };
}

const DELETED_COURSES = 'deleted_courses';
const RANKED_COURSES = 'ranked_courses';

export const localStorageCoursesMethods = {
  setRemovedCourseToLocalStorage(courseId) {
    const deletedCoursesStorage = localStorage.getItem(DELETED_COURSES);
    const deletedCourses = deletedCoursesStorage ? JSON.parse(deletedCoursesStorage) : [];
    const newDeletedCourses = deletedCourses.length > 0 ? [...deletedCourses, courseId] : [courseId];

    localStorage.setItem(DELETED_COURSES, JSON.stringify(uniq(newDeletedCourses)));
  },

  removeRemovedCourseFromLocalStorage(courseId) {
    const oldCourses = this.getRemovedCoursesFromLocalStorage();
    const newCourses = oldCourses.filter((c) => c !== courseId);
    
    localStorage.setItem(DELETED_COURSES, JSON.stringify(newCourses));

    return newCourses;
  },

  getRemovedCoursesFromLocalStorage() {
    const removedCoursesStorage = localStorage.getItem(DELETED_COURSES);
    const removedCourses = JSON.parse(removedCoursesStorage);

    return removedCourses || [];
  },

  getRemovedLocalCourse(courseId) {
    const removedCourses = this.getRemovedCoursesFromLocalStorage();

    return removedCourses.find((c) => c === courseId);
  },

  getCoursesRankingPosition() {
    const rankedCoursesStorage = localStorage.getItem(RANKED_COURSES);
    const rankedCourses = JSON.parse(rankedCoursesStorage);

    return rankedCourses || [];
  },

  getCourseRankingPosition(courseId, courses = null, findIndex = false) {
    const method = findIndex ? 'findIndex' : 'find';
    const rankedCourses = courses || this.getCoursesRankingPosition();
    const rankedCourse = rankedCourses[method]((r) => +r.course === +courseId);
    const preferenceClass = rankedCourse && getNumberByRank(rankedCourse.ranking);

    return rankedCourse && { ...rankedCourse, preference_class: preferenceClass};
  },

  addCourseRankingPosition(courseId, ranking) {
    const rankedCourses = this.getCoursesRankingPosition();
    let rankedCoursesUpdated = rankedCourses.length > 0 ? [...rankedCourses] : [];

    rankedCoursesUpdated = rankedCoursesUpdated.filter((r) => r.course !== courseId);

    const value = {
      course: courseId,
      ranking
    };

    rankedCoursesUpdated.push(value);

    localStorage.setItem(RANKED_COURSES, JSON.stringify(rankedCoursesUpdated));

    return rankedCoursesUpdated;
  },

  removeRankedCoursePosition(courseId) {
    const rankedCourses = this.getCoursesRankingPosition();
    const updatedCourses = rankedCourses.filter((c) => c.course !== courseId);

    localStorage.setItem(RANKED_COURSES, JSON.stringify(updatedCourses));

    return updatedCourses;
  }
}

export const getClassesInRangeByFilters = (startDate, endDate, filteredDays) => {
  if (!filteredDays) {
    return true;
  }

  const startDay = moment(filteredDays[0]); // initial date of the range
  const endDay = moment(filteredDays[filteredDays.length - 1]);
  const startDateMoment = moment(startDate); // initial day of the course
  const endDateMoment = moment(endDate); // end day of the course

  const inRange = startDay // checks if the start day of the picked week is between the start date and end date of the meeting
    .isBetween(startDateMoment, endDateMoment, null, '[]') ||
    endDay // checks if the end day of the picked week is between the start date and end date of the meeting
      .isBetween(startDateMoment, endDateMoment, null, '[]');

  return inRange;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js